import { render, staticRenderFns } from "./ConfirmacaoCancelamento.vue?vue&type=template&id=65f1b9a1&scoped=true"
import script from "./ConfirmacaoCancelamento.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoCancelamento.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoCancelamento.vue?vue&type=style&index=0&id=65f1b9a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f1b9a1",
  null
  
)

export default component.exports